<template>
  <div v-loading="loading" class="shop-data-item" element-loading-text="拼命加载中...">
    <div class="shop-data-item__title">{{ shopData.assetName }}</div>
    <!--商智服务生效中-->
    <div v-if="shopData.szStatus === SZ_ORDER_STATUS.EFFECTING" class="shop-data-item__block">
      <div v-for="(item, index) in shopDataArr" :key="index" class="shop-data-item__block-item">
        <div class="shop-data-item__item-title">
          <span class="shop-data-item__item-title-name">{{ item.name }}</span>
          <el-tooltip effect="dark" :offset="8" placement="bottom-end">
            <!--京喜类型tip-->
            <div v-if="shopData.shopType === SHOP_TYPE.JINGXI" slot="content" class="shop-data-item__item-tip">{{ item.jingxiTip }}</div>
            <!--pop类型tip-->
            <div v-if="shopData.shopType === SHOP_TYPE.POP" slot="content" class="shop-data-item__item-tip" v-html="item.popTip"></div>
            <i class="el-icon-question-outline shop-data-item__item-title-icon"></i>
          </el-tooltip>
        </div>
        <!--成交金额-->
        <div v-if="item.type === DATA_TYPE.AMOUNT" class="shop-data-item__item-money">
          <span
            clstag="pageclick|keycount|shopdata_tradingmoney|01"
            class="shop-data-item__money-num"
            @click="switchShop(shopData)"
          >
            <span class="shop-data-item__money-rmb">¥</span>
            <span>{{ shopData.cur.ordAmt || 0 }}</span>
          </span>
          <div class="shop-data-item__money-analysis">
            <span
              clstag="pageclick|keycount|shopdata_tradingmoney|01"
              class="shop-data-item__analysis"
              @click="switchShop(shopData)"
            >
              <span>{{ shopData.shopType === SHOP_TYPE.POP ? '昨日' : '较昨日' }}</span>
              <span>{{ (shopData.shopType === SHOP_TYPE.POP ? shopData.yday.ordAmt : shopData.thanYday.ordAmt) || 0 }}</span>
            </span>
            <span
              clstag="pageclick|keycount|shopdata_tradingmoney|01"
              class="shop-data-item__analysis"
              @click="switchShop(shopData)"
            >
              <span>{{ shopData.shopType === SHOP_TYPE.POP ? '本月' : '昨日全天' }}</span>
              <span>{{ (shopData.shopType === SHOP_TYPE.POP ? shopData.curMonth.ordAmt : shopData.yday.ordAmt) || 0 }}</span>
            </span>
          </div>
        </div>
        <!--成交总单量-->
        <div v-if="item.type === DATA_TYPE.ORDER_NUM">
          <span
            clstag="pageclick|keycount|shopdata_tradingvolume|01"
            class="shop-data-item__money-num"
            @click="switchShop(shopData)"
          >
            {{ shopData.cur.ordNum || 0 }}
          </span>
          <div class="shop-data-item__money-analysis">
            <span
              clstag="pageclick|keycount|shopdata_tradingvolume|01"
              class="shop-data-item__analysis"
              @click="switchShop(shopData)"
            >
              <span>{{ shopData.shopType === SHOP_TYPE.POP ? '昨日' : '较昨日' }}</span>
              <span>{{ (shopData.shopType === SHOP_TYPE.POP ? shopData.yday.ordNum : shopData.thanYday.ordNum) || 0 }}</span>
            </span>
            <span
              class="shop-data-item__analysis"
              clstag="pageclick|keycount|shopdata_tradingvolume|01"
              @click="switchShop(shopData)"
            >
              <span>{{ shopData.shopType === SHOP_TYPE.POP ? '本月' : '昨日全天' }}</span>
              <span>{{ (shopData.shopType === SHOP_TYPE.POP ? shopData.curMonth.ordNum : shopData.yday.ordNum) || 0 }}</span>
            </span>
          </div>
        </div>
        <!--成交客户数-->
        <div v-if="item.type === DATA_TYPE.ORDER_CUS_NUM">
          <span
            clstag="pageclick|keycount|shopdata_tradingcustomer|01"
            class="shop-data-item__money-num"
            @click="switchShop(shopData)"
          >
            {{ shopData.cur.ordCustNum || 0 }}
          </span>
          <div class="shop-data-item__money-analysis">
            <span
              class="shop-data-item__analysis"
              clstag="pageclick|keycount|shopdata_tradingcustomer|01"
              @click="switchShop(shopData)"
            >
              <span>{{ shopData.shopType === SHOP_TYPE.POP ? '昨日' : '较昨日' }}</span>
              <span>{{ (shopData.shopType === SHOP_TYPE.POP ? shopData.yday.ordCustNum : shopData.thanYday.ordCustNum) || 0 }}</span>
            </span>
            <span
              class="shop-data-item__analysis"
              clstag="pageclick|keycount|shopdata_tradingvolume|01"
              @click="switchShop(shopData)"
            >
              <span>{{ shopData.shopType === SHOP_TYPE.POP ? '本月' : '昨日全天' }}</span>
              <span>{{ (shopData.shopType === SHOP_TYPE.POP ? shopData.curMonth.ordCustNum : shopData.yday.ordCustNum) || 0 }}</span>
            </span>
          </div>
        </div>
        <!--访客数-->
        <div v-if="item.type === DATA_TYPE.VISITOR_NUM">
          <span
            clstag="pageclick|keycount|shopdata_visitorvolume|01" class="shop-data-item__money-num"
            @click="switchShop(shopData)"
          >
            {{ shopData.cur.uv || 0 }}
          </span>
          <div class="shop-data-item__money-analysis">
            <span
              class="shop-data-item__analysis"
              clstag="pageclick|keycount|shopdata_visitorvolume|01"
              @click="switchShop(shopData)"
            >
              <span>{{ shopData.shopType === SHOP_TYPE.POP ? '昨日' : '较昨日' }}</span>
              <span>{{ (shopData.shopType === SHOP_TYPE.POP ? shopData.yday.uv : shopData.thanYday.uv) || 0 }}</span>
            </span>
            <span
              class="shop-data-item__analysis"
              clstag="pageclick|keycount|shopdata_visitorvolume|01"
              @click="switchShop(shopData)"
            >
              <span>{{ shopData.shopType === SHOP_TYPE.POP ? '本月' : '昨日全天' }}</span>
              <span>{{ (shopData.shopType === SHOP_TYPE.POP ? shopData.curMonth.uv : shopData.yday.uv) || 0 }}</span>
            </span>
          </div>
        </div>
      </div>
      <div class="shop-data-item__item-time">
        <span class="shop-data-item__time-info">
          <span>{{ '更新时间' + shopData.dataTime }}</span>
          <span class="el-icon-refresh shop-data-item__time-refresh"
                clstag="pageclick|keycount|shopdata_update|01"
                @click="handleRefreshData(shopData.id)"
          >
          </span>
        </span>
        <a
          class="shop-data-item__time-sz"
          clstag="pageclick|keycount|shopdata_jumpSZ|01"
          @click="switchShop(shopData)"
        >
          <span>商智</span>
          <i class="el-icon-arrow-right"></i>
        </a>
      </div>
    </div>
    <!--服务过期或未订购-->
    <div v-if="shopData.szStatus === SZ_ORDER_STATUS.INVALID" class="shop-data-item__no-data">
      <img src="https://img11.360buyimg.com/imagetools/jfs/t1/215868/26/3532/24615/61879fb4E1e3d8ff8/f20e35cc53cedc09.png" alt="缺省图" class="shop-data-item__no-data-img">
      <div class="shop-data-item__no-data-title">访问受限</div>
      <div class="shop-data-item__no-data-desc">
        <span>尚未订购或订购过期，请您使用主账号前往京麦服务市场</span>
        <a href="https://fw.jd.com/main/detail/FW_GOODS-549810" target="_blank" class="shop-data-item__no-data-a">订购</a>
        <span>；如果您已订购仍然访问受限，请您</span>
        <a href="https://jdcs.jd.com/jd/chat?entry=jd_web_jingmai" target="_blank" class="shop-data-item__no-data-a">联系客服</a>
      </div>
    </div>
  </div>
</template>

<script>
import {
  changeShop,
  sessionSave,
  nplogin,
} from '@/api/apis/switchShop';
import shopList from '../../../api/apis/home';
import { isJMSupportQY } from '../../../utils/jmsdk';
import { SZ_ORDER_STATUS, SHOP_TYPE, DATA_TYPE } from '../../../config';

export default {
  name: 'ShopDataItem',
  props: {
    shopDataItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      SZ_ORDER_STATUS,
      SHOP_TYPE,
      DATA_TYPE,
      shopData: {}, // 单个店铺数据
      shopDataArr: [{
        name: '成交金额',
        popTip: '统计时间内，用户付款的总金额，包括先款订单的金额(在线支付、公司转账、邮局汇款等)和货到付款的金额。<br/>统计时间范围如下：<br/>实时：从今日00:00至您最近一次刷新本页面或点击刷新按钮。<br/>昨日：昨日00:00-24:00。<br/>本月：本月1日至昨日24:00。',
        jingxiTip: '从今日0点到现在，成交订单包含商品的总金额。',
        type: DATA_TYPE.AMOUNT,
      }, {
        name: '成交总单量',
        popTip: '统计时间内，用户付款的总订单量，包括先款订单量(在线支付、公司转账、邮局汇款等)和货到付款订单量。<br/>统计时间范围如下：<br/>实时：从今日00:00至您最近一次刷新本页面或点击刷新按钮。<br/>昨日：昨日00:00-24:00。<br/>本月：本月1日至昨日24:00。',
        jingxiTip: '从今日0点到现在，成交订单的总订单数。',
        type: DATA_TYPE.ORDER_NUM,
      }, {
        name: '成交客户数',
        popTip: '统计时间内，用户付款的总订单量，包括先款订单量(在线支付、公司转账、邮局汇款等)和货到付款订单量。<br/>统计时间范围如下：<br/>实时：从今日00:00至您最近一次刷新本页面或点击刷新按钮。<br/>昨日：昨日00:00-24:00。<br/>本月：本月1日至昨日24:00。',
        jingxiTip: '从今日0点到现在，完成成交订单的去重人数。',
        type: DATA_TYPE.ORDER_CUS_NUM,
      }, {
        name: '访客数',
        popTip: '统计时间内，用户付款的总订单量，包括先款订单量(在线支付、公司转账、邮局汇款等)和货到付款订单量。<br/>统计时间范围如下：<br/>实时：从今日00:00至您最近一次刷新本页面或点击刷新按钮。<br/>昨日：昨日00:00-24:00。<br/>本月：本月1日至昨日24:00。',
        jingxiTip: '从今日0点到现在，商品详情页面被访问的去重人数。同一访客多次访问只被计算一次。',
        type: DATA_TYPE.VISITOR_NUM,
      }],
      loading: false,
      eid: '',
    };
  },
  watch: {
    shopDataItem: {
      handler(val) {
        this.shopData = val;
      },
      immediate: true,
    },
  },
  created() {
    this.getEid();
  },
  methods: {
    // 刷新数据
    handleRefreshData(id) {
      this.getShopData(id);
    },
    // 获取店铺数据
    async getShopData(id) {
      try {
        this.loading = true;
        const shopData = await shopList(id);
        if (shopData.code === 200) {
          this.shopData = shopData.data.shopData;
          this.loading = false;
        } else {
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
        this.$message.error(error || '获取店铺数据失败');
      }
    },
    // 获取设备指纹
    getEid() {
      try {
        window.getJdEid((eid) => {
          this.eid = eid;
        });
      } catch (e) {
        console.error('获取设备指纹失败！');
      }
    },
    // 切店
    async switchShop(shopItem) {
      // 如果是在京麦客户端中，且京麦支持企业账号，则使用京麦的切店 jssdk
      if (isJMSupportQY) {
        window.jmsdkPC.switchShop({
          vendorId: shopItem.venderId,
          pin: shopItem.venderPin,
          vendorType: shopItem.venderType,
        });

        return;
      }

      this.loading = true;
      const params = {
        eid: this.eid,
        vendorId: shopItem.venderId,
        vendorPin: shopItem.venderPin,
        vendorType: shopItem.venderType,
      };
      // 接口逻辑：
      // 1-1 code 10 当前店铺未授权，请联系管理员授权，（需要提示商家）
      // 1-2 code 10 店铺账号已被停用，请联系管理员处理，(需要提示商家)
      // 1-3 code 10 账号冻结，请联系客服（400-606-5500）进行处理 (需要提示商家)
      // 1-4 code 10 账号因安全临时被锁，请将账号和联系方式发送到shensu@jd.com等待处理（需要提示商家）
      // 1-5 code 10 ip在黑名单，IP服务受限，请联系客服（400-606-5500）进行处理（需要提示商家）
      // 1-6 code 11 服务器繁忙，请稍后重试！（需要提示商家）
      const res = await changeShop(params);
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      if (code === 200) {
        this.noLoginToken = data.noLoginToken;
        this.vendorToken = data.vendorToken;
        this.loading = false;
        this.setCookie(shopItem);
      } else if ([10, 11].includes(code)) {
        this.$alert(message || '账号异常', {
          callback: () => {
            this.loading = false;
          },
        });
      } else {
        this.loading = false;
        this.$message.error(message || '系统繁忙请重试');
      }
    },
    // 下发免登
    async setCookie(shopItem) {
      this.loading = true;
      const params = {
        eid: this.eid,
        from: 'pop_login',
        t: this.noLoginToken,
      };
      // code 100 成功
      // code 0 服务器繁忙，请稍后重试！（需要提示商家）
      const res = await nplogin(params);
      const {
        // eslint-disable-next-line no-unused-vars
        code, msg,
      } = res;
      if (Number(code) === 100) {
        this.saveTalk(shopItem);
      } else {
        this.$message.error(msg || '下发免登失败，请稍后重试');
      }
      this.loading = false;
    },
    // 保存会话
    async saveTalk(shopItem) {
      this.loading = true;
      const params = {
        vendorId: shopItem.venderId,
        vendorType: shopItem.venderType,
        vendorToken: this.vendorToken,
      };
      // code=200，接口访问成功，跳转至重定向url。
      // code=12，接口访问失败，需要弹框提示（message）商家，商家点击”知道了“，跳转至重定向url
      const res = await sessionSave(params);
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      if (code === 200) {
        this.loading = false;
        window.open(shopItem.szSummaryUrl);
      } else if ([12].includes(code)) {
        this.$alert(message || '账号异常', {
          callback: () => {
            window.location = data.redirectUrl;
          },
        });
      } else {
        this.loading = false;
        this.$message.error(message || '保存会话失败，请稍后重试');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.shop-data-item {
  width: 327px;
  height: 394px;
  border: 1px solid rgba(0,0,0,0.09);
  box-sizing: border-box;
  border-radius: 8px;
  margin-right: 10px;
  &:last-child {
    margin-right: 0;
  }
  .shop-data-item__title {
    margin: 20px 0 20px 15px;
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 18px;
    font-size: 14px;
    font-weight: 600;
    color: rgba(38,38,38,1);
  }
  .shop-data-item__item-title-name {
    margin-right: 6px;
  }
  .shop-data-item__block {
    display: flex;
    flex-wrap: wrap;
  }
  .shop-data-item__block-item {
    width: 162px;
    height: 139px;
    padding: 0 15px;
    box-sizing: border-box;
    &:nth-child(1) {
      border-right: 1px solid rgba(0,0,0,0.09);
      border-bottom: 1px solid rgba(0,0,0,0.09);
      padding-bottom: 20px;
    }
    &:nth-child(2) {
      border-bottom: 1px solid rgba(0,0,0,0.09);
      padding-bottom: 20px;
    }
    &:nth-child(3) {
      padding-top: 15px;
      border-right: 1px solid rgba(0,0,0,0.09);
      padding-bottom: 6px;
    }
    &:nth-child(4) {
      padding-top: 15px;
      padding-bottom: 6px;
    }
  }
  .shop-data-item__item-title {
    margin-bottom: 15px;
    line-height: 14px;
    font-size: 14px;
    color: rgba(89,89,89,1);
  }
  .shop-data-item__item-title-icon {
    font-size: 14px;
    color: #979797;
    cursor: pointer;
  }
  .shop-data-item__money-num {
    display: inline-block;
    line-height: 28px;
    font-size: 18px;
    font-family: JDZhengHT-Regular;
    color: rgba(77,128,240,1);
    word-wrap: break-word;
    margin-bottom: 19px;
    cursor: pointer;
    &:hover {
     color: #5aa0ff;
    }
  }
  .shop-data-item__money-rmb {
    font-size: 12px;
    color: #4D80F0;
  }
  .shop-data-item__analysis {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 17px;
    font-size: 12px;
    color: rgba(0,0,0,0.85);
    cursor: pointer;
    &:first-child {
      margin-bottom: 4px;
    }
    &:nth-child(2) {
      margin-bottom: 2px;
    }
    &:hover {
     color: #4D80F0;
    }
  }
  .shop-data-item__item-time {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin: 20px 15px 0 15px;
    line-height: 14px;
    font-size: 14px;
    color: rgba(89,89,89,1);
  }
  .shop-data-item__time-refresh {
    margin-left: 5px;
    cursor: pointer;
    color: rgba(0,0,0,0.45);
    &:hover {
      color: #4D80F0;
    }
  }
  .shop-data-item__time-sz {
    font-size: 12px;
    color: rgba(77,128,240,1);
    cursor: pointer;
    &:hover {
      color: #5aa0ff;
    }
  }
  .shop-data-item__no-data {
    font-size: 0;
    padding: 37px 15px 0;
    text-align: center;
  }
  .shop-data-item__no-data-img {
    width: 154px;
    height: 104px;
  }
  .shop-data-item__no-data-title {
    margin-top: 27px;
    line-height: 17px;
    font-size: 12px;
    color: #595959;
  }
  .shop-data-item__no-data-desc {
    line-height: 17px;
    font-size: 12px;
    color: rgba(89,89,89,1);
  }
  .shop-data-item__no-data-a {
    font-size: 12px;
    color: rgba(77,128,240,1);
    &:hover {
      color: #5aa0ff;
    }
  }
}
.shop-data-item__item-tip {
  font-size: 12px;
  color: rgba(255,255,255,1);
  width: 158px;
}
</style>
